import React from "react";
import { useHistory } from "react-router-dom";
import FieldTimeOutlined from "@ant-design/icons/FieldTimeOutlined";

function SessionExpired() {
  const history = useHistory();
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "80vh",
        flexDirection: "column",
      }}
    >
      <span style={{ fontSize: 100, color: "red" }}>
        <FieldTimeOutlined />
      </span>
      <h1>Session expired</h1>
      <button
        style={{
          padding: "5px 10px",
          background: "#005EAC",
          color: "#fff",
          fontWeight: "bold",
          border: "none",
          borderRadius: 5,
          cursor: "pointer",
          width: 100,
        }}
        onClick={() => history.push("/login")}
      >
        Login
      </button>
    </div>
  );
}

export default SessionExpired;
